import React, {FunctionComponent, useEffect, useRef, useState} from "react";
import {VariableSizeList as List} from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import StationLine from "@/Domains/DispositionManagement/Components/DispositionBody/Elements/StationLine";
import VehicleLine from "@/Domains/DispositionManagement/Components/DispositionBody/Elements/VehicleLine";
import GroupReservationLine from "@/Domains/DispositionManagement/Components/DispositionBody/Elements/GroupReservationLine";
import {RootStateOrAny, useSelector} from "react-redux";
import {DndProvider} from "react-dnd";
import {CustomDragLayer} from "@/Components/CustomDragLayer/CustomDragLayer";
import {
    selectData,
    selectHiddenStations,
    selectHideUnavailableVehicles,
    selectHideVehiclesInStations,
    selectShowArrivingVehicles,
    selectShowOnlyGroupResOfStation,
} from "@/Redux/Disposition/DispositionReducer";
import ArrivingVehicles from "@/Domains/DispositionManagement/Components/DispositionBody/Elements/ArrivingVehicles";
import {useAppSelector} from "@/Redux/Redux";
import moment from "moment/moment";
import {logger} from "@/Logger";
import {ScrollBottomDropTarget} from "@/Components/CustomDragLayer/ScrollBottomDropTarget";
import {ScrollTopDropTarget} from "@/Components/CustomDragLayer/ScrollTopDropTarget";
import {TouchBackend} from "react-dnd-touch-backend";
import {HTML5Backend} from "react-dnd-html5-backend";

interface DispositionBodyProps {
    contentWidth: number | undefined;
    viewData?: any;
}

const DispositionBody: FunctionComponent<DispositionBodyProps> = ({
                                                                      contentWidth,
                                                                      viewData
                                                                  }): JSX.Element => {
    const data = useSelector((state) => selectData(state));
    const hiddenStations = useSelector((state) => selectHiddenStations(state));
    const hideVehiclesInStations = useSelector((state) =>
        selectHideVehiclesInStations(state)
    );
    const showArrivingVehicles = useSelector((state) =>
        selectShowArrivingVehicles(state as RootStateOrAny)
    );
    const hideNotAvailableVehicles = useSelector((state) =>
        selectHideUnavailableVehicles(state)
    );
    const selectedStation = localStorage.getItem("CRENT_WEB/SELECTED_STATION");
    const showOnlyGroupResOfStation = useSelector((state) =>
        selectShowOnlyGroupResOfStation(state as RootStateOrAny)
    );
    const lastStyle: any = [];
    let searchIndex = 0;
    let stationsPassed = 0;
    let lineNumber = 0;
    const listRef = useRef(null);

    logger.log("Disposition hideVehiclesInStations: ", hideVehiclesInStations);
    logger.log("Disposition showArrivingVehicles: ", showArrivingVehicles);
    logger.log(
        "Disposition hideNotAvailableVehicles: ",
        hideNotAvailableVehicles
    );
    logger.log("Disposition selectedStation: ", selectedStation);
    logger.log(
        "Disposition showOnlyGroupResOfStation: ",
        showOnlyGroupResOfStation
    );

    const createMappings = () => {
        const temp = {};

        data.forEach(d => {
            if (d.__typename == "Station") {
                temp[d.stationId] = [];
            }

            return;
            //d.vehicles.forEach(v => temp[d.stationId].push(v));
        })

        data.forEach(d => {
            if (d.__typename == "SimpleVehicle") {
                if (showArrivingVehicles && d.stationArriving) {
                    return;
                }

                temp[d.location.stationId].push(d);
            }

            return;
        })

        return temp;
    }

    const [mappings, setMappings] = useState(null);

    if (!mappings && data) {
        setMappings(createMappings());
    }

    const [maybeUnloadedElementSnapshot, setMaybeUnloadedElementSnapshot] =
        useState(0);

    const tryGetDispositionContent = () => {
        // @ts-ignore
        if (
            document.getElementById("dispo_content") &&
            maybeUnloadedElementSnapshot === 0
        ) {
            // @ts-ignore
            setMaybeUnloadedElementSnapshot(
                parseInt(document.getElementById("dispo_content").style.width)
            );
        } else {
            setTimeout(tryGetDispositionContent, 200);
        }
    };

    tryGetDispositionContent();

    const {
        dispoWidth,
        days,
        hours,
        dayWidth,
        dispositionControlsTop,
        dispositionControlsHeight,
    } = useAppSelector((state) => state.disposition);

    const {dispositionStartdate, dispositionEnddate} = useAppSelector(
        (state) => state.disposition
    );

    useEffect(() => {
        if (listRef?.current != null) {
            // @ts-ignore
            listRef.current.resetAfterIndex(0);
        }
    }, [
        data,
        hiddenStations,
        hideVehiclesInStations,
        showArrivingVehicles,
        hideNotAvailableVehicles,
        showOnlyGroupResOfStation,
    ]);

    stationsPassed = 2;
    lineNumber = 0;

    for (const index in data) {
        if (data[index].__typename == 'Station' || data[index].__typename == "ArrivingVehicles") {
            stationsPassed--;
        }

        if (data[index].isSearchResult) {
            lineNumber++;

            if (data[index].__typename == "SimpleVehicle") {
                lineNumber++;
            }

            searchIndex = parseInt(index);
            break;
        }

        if (data[index].__typename == "SimpleVehicle") {
            lineNumber++;
        }
    }

    // @ts-ignore
    const getDateTimeDictionary = () => {
        try {
            let _date = new Date();
            _date.setHours(0, 0, 0, 0);

            // @ts-ignore
            const dateTimePosX =
                ((document.getElementById("dispo_content")
                        ? parseInt(
                            document.getElementById("dispo_content").style.width
                        )
                        : maybeUnloadedElementSnapshot) *
                    (dayWidth / 100)) /
                96;

            let dateTimePosXCurrent = 0;

            const _tempDictionary = {};

            for (let i = 0; i < 96; i++) {
                // @ts-ignore
                _tempDictionary[
                    dateTimePosXCurrent
                    ] = `${_date.getHours()}:${_date.getMinutes()}`;
                _date = moment(_date).add(15, "m").toDate();
                dateTimePosXCurrent += dateTimePosX;
            }

            return _tempDictionary;
        } catch (e) {
            console.error(e);
            return null;
        }
    };

    // @ts-ignore
    const getDateTimeDictionaryOneDay = () => {
        try {
            let _date = new Date();
            _date.setHours(0, 0, 0, 0);

            // @ts-ignore
            const dateTimePosX =
                ((document.getElementById("dispo_content")
                        ? parseInt(
                            document.getElementById("dispo_content").style.width
                        )
                        : maybeUnloadedElementSnapshot) *
                    (dayWidth / 100)) /
                4;

            let dateTimePosXCurrent = 0;

            const _tempDictionary = {};

            for (let i = 0; i < 96; i++) {
                // @ts-ignore
                _tempDictionary[
                    dateTimePosXCurrent
                    ] = `${_date.getHours()}:${_date.getMinutes()}`;
                _date = moment(_date).add(15, "m").toDate();
                dateTimePosXCurrent += dateTimePosX;
            }

            return _tempDictionary;
        } catch (e) {
            console.error(e);
            return null;
        }
    };

    // @ts-ignore
    const Row = ({index, style}) => {
        const item = data[index];
        if (
            item.__typename == "SimpleVehicle" ||
            item.__typename == "GroupReservation" ||
            item.__typename == "ArrivingVehicles"
        ) {
            lastStyle[index] = {...style, left: "306px", width: "auto"};
        }

        if (
            item.__typename == "SimpleVehicle" &&
            hideNotAvailableVehicles.indexOf(item.location.stationId) !== -1
        ) {
            let skip = false;

            if (item.availableFrom && item.availableUntil) {
                skip =
                    Date.parse(item.availableUntil) <=
                    Date.parse(dispositionStartdate) ||
                    Date.parse(item.availableFrom) >=
                    Date.parse(dispositionEnddate);
            }

            // Check foreach reservation object startdate and enddate and match with dispostart and dispoend
            if (!skip && item.reservations) {
                // @ts-ignore
                item.reservations.forEach((reservation) => {
                    if (!reservation.vehicle) {
                        return;
                    }

                    if (skip) {
                        return;
                    }

                    if (!reservation || reservation.length == 0) {
                        return;
                    }

                    if (
                        Date.parse(reservation.startdate) <=
                        Date.parse(dispositionStartdate) &&
                        Date.parse(reservation.plannedEnddate) >=
                        Date.parse(dispositionEnddate)
                    ) {
                        skip = true;
                    }

                    const today = new Date();

                    if (
                        Date.parse(reservation.startdate) >= today.valueOf() ||
                        (reservation.enddate
                            ? Date.parse(reservation.enddate)
                            : Date.parse(reservation.plannedEnddate)) >=
                        today.valueOf()
                    ) {
                        skip = true;
                    }
                });
            }

            if (skip) {
                return null;
            }
        }

        if (item.__typename === "Station") {
            if (mappings[item.stationId].length == 0) {
                return null;
            }

            return (
                <div style={style}>
                    <StationLine
                        lineItem={item}
                        hideNotAvailableVehicles={hideNotAvailableVehicles}
                        dateTimeDictionary={dateTimeDictionary}
                        dateTimeDictionaryOneDay={dateTimeDictionaryOneDay}
                    />
                </div>
            );
        }
        if (
            item.__typename === "GroupReservation" &&
            hiddenStations.indexOf(item.startstation) <= -1
        ) {
            if (
                showOnlyGroupResOfStation &&
                selectedStation != item.startstation
            ) {
                return <></>;
            }
            return (
                <div style={style}>
                    <GroupReservationLine
                        lineItem={item}
                        contentWidth={contentWidth}
                        viewData={viewData}
                    />
                </div>
            );
        }

        if (item.__typename === "SimpleVehicle") {
            if (
                item.isArriving === undefined &&
                (hiddenStations.indexOf(item.location.stationId) >= 0 ||
                    hideVehiclesInStations.indexOf(item.location.stationId) >=
                    0)
            ) {
                return null;
            } else if (item.isArriving && !showArrivingVehicles) {
                return null;
            }

            if (!item.isArriving && showArrivingVehicles && item.stationArriving) {
                return null;
            }

            if (item.stationArriving && !showArrivingVehicles) {
                return null;
            }
            //if (item.isArriving === undefined) {
            return (
                <div style={style}>
                    <VehicleLine
                        lineItem={item}
                        contentWidth={contentWidth}
                        dateTimeDictionary={dateTimeDictionary}
                        dateTimeDictionaryOneDay={dateTimeDictionaryOneDay}
                        viewData={viewData}
                    />
                </div>
            );
            //} else {
            //    if (item.isArriving != undefined && showArrivingVehicles) {
            //        return (
            //            <div style={style}>
            //                <VehicleLine lineItem={item}
            //                             contentWidth={contentWidth} />
            //            </div>
            //        )
            //    }
            //}
        }

        if (item.__typename === "ArrivingVehicles") {
            return (
                <div style={style}>
                    <ArrivingVehicles lineItem={item}/>
                </div>
            );
        }

        return null;
    };

    // @ts-ignore
    const isVehicleAvailable = (index: any) => {
        const item = data[index];

        if (
            item.__typename == "SimpleVehicle" &&
            hideNotAvailableVehicles.indexOf(item.location.stationId) !== -1
        ) {
            let skip = false;

            if (item.availableFrom && item.availableUntil) {
                skip =
                    Date.parse(item.availableUntil) <=
                    Date.parse(dispositionStartdate) ||
                    Date.parse(item.availableFrom) >=
                    Date.parse(dispositionEnddate);
            }

            // Check foreach reservation object startdate and enddate and match with dispostart and dispoend
            if (!skip && item.reservations) {
                // @ts-ignore
                item.reservations.forEach((reservation) => {
                    if (!reservation.vehicle) {
                        return;
                    }

                    if (skip) {
                        return;
                    }

                    if (!reservation || reservation.length == 0) {
                        return;
                    }

                    if (
                        Date.parse(reservation.startdate) <=
                        Date.parse(dispositionStartdate) &&
                        Date.parse(reservation.plannedEnddate) >=
                        Date.parse(dispositionEnddate)
                    ) {
                        skip = true;
                    }

                    const today = new Date();

                    if (
                        Date.parse(reservation.startdate) >= today.valueOf() ||
                        (reservation.enddate
                            ? Date.parse(reservation.enddate)
                            : Date.parse(reservation.plannedEnddate)) >=
                        today.valueOf()
                    ) {
                        skip = true;
                    }
                });
            }

            if (skip) {
                return true;
            }

            return false;
        }
    };

    let reduceDispoHeight: number;
    const headerHeight =
        document.getElementById("disposition_header")?.clientHeight || 0;
    const controlsHeight =
        document.getElementById("dispo-controls-main")?.clientHeight || 0;
    const infoHeight =
        document.getElementById("disposition_header_info")?.clientHeight || 0;
    const contentContainerHeight =
        document.getElementById("content-container")?.clientHeight || 0;

    reduceDispoHeight =
        contentContainerHeight - (headerHeight + controlsHeight + infoHeight);
    const dateTimeDictionary = getDateTimeDictionary();
    const dateTimeDictionaryOneDay = getDateTimeDictionaryOneDay();

    const ref = useRef(null);
    const outerRef = useRef<HTMLDivElement | null>(null);

    return (
        <>
            <AutoSizer>
                {
                    // @ts-ignore
                    ({width, height}) => {
                        return (
                            <DndProvider
                                backend={TouchBackend}
                                debugMode={true}
                                options={{
                                    enableMouseEvents: true,
                                }}
                            >
                                <CustomDragLayer/>
                                <ScrollTopDropTarget listItemRef={outerRef}/>
                                <List
                                    className={"scroll-this"}
                                    style={{overflowX: "hidden"}}
                                    width={width}
                                    height={reduceDispoHeight - 12}
                                    estimatedItemSize={56}
                                    ref={listRef}
                                    innerRef={ref}
                                    outerRef={outerRef}
                                    initialScrollOffset={searchIndex ? ((lineNumber - stationsPassed) * 56) : 0}
                                    itemSize={(index) => {
                                        const item = data[index];

                                        if (isVehicleAvailable(index)) {
                                            return 0;
                                        }

                                        if (item.__typename === "Station" && mappings[item.stationId].length == 0) {
                                            return 0;
                                        }

                                        if (item.__typename === "SimpleVehicle" &&
                                            !showArrivingVehicles &&
                                            item.stationArriving &&
                                            !mappings[item.location.stationId].find((vehicle => vehicle == item))) {
                                            return 0;
                                        }

                                        if (
                                            item.__typename === "Station" ||
                                            item.__typename ===
                                            "ArrivingVehicles"
                                        ) {
                                            return 64;
                                        }
                                        if (item.__typename === "SimpleVehicle") {
                                            if (
                                                item.isArriving === undefined &&
                                                (hiddenStations.indexOf(
                                                        item.location.stationId
                                                    ) >= 0 ||
                                                    hideVehiclesInStations.indexOf(
                                                        item.location.stationId
                                                    ) >= 0)
                                            ) {
                                                return 0;
                                            } else if (
                                                item.isArriving &&
                                                !showArrivingVehicles
                                            ) {
                                                return 0;
                                            }
                                            if (!item.isArriving && showArrivingVehicles && item.stationArriving) {
                                                return 0;
                                            }
                                            return 56;
                                        }
                                        if (
                                            item.__typename ===
                                            "GroupReservation" &&
                                            hiddenStations.indexOf(
                                                item.startstation
                                            ) <= -1
                                        ) {
                                            if (
                                                showOnlyGroupResOfStation &&
                                                selectedStation !=
                                                item.startstation
                                            ) {
                                                return 0;
                                            }
                                            return 56;
                                        }
                                        return 0;
                                    }}
                                    itemCount={data.length}
                                >
                                    {Row}
                                </List>
                                <ScrollBottomDropTarget listItemRef={outerRef}/>
                            </DndProvider>
                        );
                    }
                }
            </AutoSizer>
        </>
    );
};

export default React.memo(DispositionBody);
